export const roomsData = [
  {
    id: "room-1",
    name: "海側和洋室",
    subtitle: "稲取の海を望む特別室",
    capacity: "2〜4名",
    size: "10畳+洋間",
    features: ["露天風呂付", "海側", "Wi-Fi完備"],
    price: "¥15,000〜/人",
    image:
      "https://storage.readdy-site.link/project_files/b101d8e3-eb8f-4b23-a967-4f4a49b8c766/bbce4e02-9820-4b6b-8dd9-9f434fab0ead_room01.png?v=cd1e61b6a6e3607c28e1af6677c5f660",
    description:
      "稲取の海を正面に望む海側の特別室。和の空間と洋間が融合した寛ぎのお部屋で、窓からの絶景と天然温泉露天風呂を独占できます。",
  },
  {
    id: "room-2",
    name: "海側和室",
    subtitle: "純和風の寛ぎ空間",
    capacity: "2〜3名",
    size: "8畳",
    features: ["海側", " Wi-Fi完備", "洗面付"],
    price: "¥12,000〜/人",
    image:
      "https://storage.readdy-site.link/project_files/b101d8e3-eb8f-4b23-a967-4f4a49b8c766/1dcb2eff-6ac9-4377-af0c-7ac3631fec60_room02.png?v=235160f328b6f13f94734560184c5f85",
    description:
      "純和風の落ち着いた空間で、日常の喧騒を忘れて心身ともに癒されるひとときを。海の景色を眺めながらゆっくりとお寛ぎください。",
  },
  {
    id: "room-3",
    name: "本館和室",
    subtitle: "家庭的な雰囲気のお部屋",
    capacity: "2名",
    size: "6畳",
    features: ["Wi-Fi完備", "洗面付", "庭側"],
    price: "¥10,000〜/人",
    image:
      "https://storage.readdy-site.link/project_files/b101d8e3-eb8f-4b23-a967-4f4a49b8c766/469f6a57-cee0-4488-8348-1a0eb82f3e33_room03.png?v=44e2770df6e2b0f5fa3930214a90db1f",
    description:
      "家庭的な雰囲気漂う本館の和室。気軽に温泉旅を楽しみたい方に最適です。全室禁煙で清潔感のある空間をご用意しています。",
  },
];

export const onsenData = {
  springQuality: "単純温泉（弱アルカリ性・低張性・低温泉）",
  temperature: "源泉温度 約42℃",
  effects:
    "神経痛・筋肉痛・関節痛・冷え性・疲労回復・健康増進",
  baths: [
    {
      name: "大浴場",
      description: "檜造りの内湯と露天風呂をご用意。海を眺めながらゆったりと湯に浸かれます。",
      image:
        "https://readdy.ai/api/search-image?query=Japanese%20onsen%20hot%20spring%20bathhouse%20interior%20with%20cypress%20wood%20walls%2C%20steam%20rising%20from%20hot%20water%2C%20serene%20atmosphere%2C%20traditional%20Japanese%20public%20bath%2C%20soft%20warm%20lighting%2C%20relaxing%20spa%20environment&width=800&height=600&seq=bath1&orientation=landscape",
    },
    {
      name: "露天風呂",
      description: "海と水平線を望む開放的な露天風呂。星空の下での入浴も格別です。",
      image:
        "https://readdy.ai/api/search-image?query=Japanese%20outdoor%20onsen%20rotenburo%20hot%20spring%20bath%20with%20ocean%20view%2C%20wooden%20fence%2C%20steam%20rising%2C%20sunset%20sky%2C%20traditional%20Japanese%20open-air%20bath%20overlooking%20sea%20horizon%2C%20serene%20relaxing%20atmosphere&width=800&height=600&seq=bath2&orientation=landscape",
    },
  ],
};

export const testimonialData = [
  {
    id: 1,
    text: "窓から見える海と、露天風呂の湯の匂い。ここに来ると、本当に身も心も洗われるようです。料理も新鮮で、毎回来るのが楽しみです。",
    author: "東京都在住 K様",
  },
  {
    id: 2,
    text: "3室だけの小さな宿だからこそ、まるで実家に帰ったような安心感。ご主人と女将さんの温かいおもてなしが最高です。",
    author: "神奈川県在住 M様",
  },
  {
    id: 3,
    text: "稲取の海を眺めながらの露天風呂は格別。夜は満点の星空が見えて、都会の疲れが吹き飛びます。絶対また来ます。",
    author: "大阪府在住 S様",
  },
];